/*
  UpdateBasicInfo
*/

import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { connectModal as reduxModal, hide as hideModal } from 'redux-modal';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { submit } from 'redux-form';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';
import classnames from 'classnames';
import styles from './index.module.scss';
import SubmitButton from 'ui/common/form/submit-button';
import * as actionTypes from 'store/graphql/UpdateBasicInfo/action-types';
import { selectUpdating } from 'store/graphql/UpdateBasicInfo/selectors';
import Form, { FORM_NAME } from './form';
import { convertToDataURL, isFile } from 'utils/file';
import { updateCurrentUser } from 'store/features/auth/actions';
import { selectCurrentUserId } from 'store/features/auth/selectors';
import { camelizeApiResponseFragment } from 'utils/humps';

import { compose, bindActionCreators } from 'redux';
import injectReducer from 'utils/injectReducer';
import UpdateBasicInfoReducer from 'store/graphql/UpdateBasicInfo/reducer';

export const MODAL_NAME = 'update-basic-info';

const messages = defineMessages({
  title: {
    id: 'edit-user-basic-info.title',
    defaultMessage: 'Edit Information',
  },
  save: {
    id: 'edit-user-basic-info.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'edit-user-basic-info.cancel',
    defaultMessage: 'Cancel',
  },
});

class UpdateBasicInfo extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  async onSubmit(values) {
    const { bio, img, name, education, aggregateExperience, country: location } = values;
    const {
      currentUserId,
      client,
      updateBasicInfoStart,
      updateBasicInfoSuccess,
      updateBasicInfoFailure,
    } = this.props;

    updateBasicInfoStart();
    // convert img to base64
    let imgData = null;
    if (img && isFile(img)) {
      imgData = await convertToDataURL(img);
    }

    let variables = {
      name,
      imgData,
      bio,
      yearsOfExperience: 0,
      highestEducation: education,
      aggregateExperience,
    };

    if (location && location.value) {
      variables = { ...variables, location: location.value };
    }

    const resultFromGraphql = await client.mutate({
      mutation: gql`
        mutation updateProfile(
          $name: String!
          $imgData: String
          $bio: String
          $yearsOfExperience: Int
          $highestEducation: HighestEducation
          $aggregateExperience: Float
          $location: String
        ) {
          profileUpdate(
            name: $name
            imgData: $imgData
            bio: $bio
            yearsOfExperience: $yearsOfExperience
            highestEducation: $highestEducation
            aggregateExperience: $aggregateExperience
            location: $location
          ) {
            profileUpdated
            user {
              name
              bio
              yearsOfExperience
              img_url
              photo_ipfs
              aggregateExperience
              highestEducation
              location
            }
          }
        }
      `,
      variables,
    });

    if (!resultFromGraphql.errors) {
      const user = camelizeApiResponseFragment(resultFromGraphql.data.profileUpdate.user);
      updateBasicInfoSuccess({
        profile: user,
      });
      this.props.updateCurrentUser({
        profile: {
          ...user,
          id: currentUserId, // VERY IMPORTANT, this will update bio description
        },
      });
      this.props.hideModal(MODAL_NAME);
    } else {
      const { message } = resultFromGraphql.errors[0];
      updateBasicInfoFailure({ error: message });
    }
  }

  render() {
    const { show, intl: { formatMessage }, handleHide, updating } = this.props;

    return (
      <Modal size="lg" isOpen={show}>
        <ModalHeader toggle={handleHide} />
        <ModalBody>
          <div className="col-12">
            <h1 className={classnames(styles.mainTitle)}>{formatMessage(messages.title)}</h1>
            <div className={classnames(styles.line)} />
          </div>
          <Form onSubmit={this.onSubmit} />
        </ModalBody>
        <ModalFooter className="mx-auto mb-4">
          <SubmitButton
            isReady={false}
            formName={FORM_NAME}
            loading={updating}
            className={classnames(styles.saveBtn)}
            explicitlyTriggerSubmit
          >
            {formatMessage(messages.save)}
          </SubmitButton>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUserId: selectCurrentUserId(state),
    updating: selectUpdating(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submit: bindActionCreators(submit, dispatch),
    hideModal: bindActionCreators(hideModal, dispatch),
    updateCurrentUser: bindActionCreators(updateCurrentUser.success, dispatch),
    updateBasicInfoStart: () =>
      dispatch({
        type: actionTypes.UPDATE_BASIC_INFO.START,
      }),
    updateBasicInfoSuccess: ({ profile }) =>
      dispatch({
        type: actionTypes.UPDATE_BASIC_INFO.SUCCESS,
        payload: { profile },
      }),
    updateBasicInfoFailure: ({ error }) =>
      dispatch({
        type: actionTypes.UPDATE_BASIC_INFO.FAILURE,
        payload: { error },
      }),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: 'UpdateBasicInfo',
  reducer: UpdateBasicInfoReducer,
});

export default compose(withReducer, withConnect)(
  reduxModal({
    name: MODAL_NAME,
  })(injectIntl(withApollo(UpdateBasicInfo)))
);



// WEBPACK FOOTER //
// ./src/ui/graphql/UpdateBasicInfo/index.js